import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { ButtonSize, ButtonStyle } from '@constants/button/1.0';
import { LoadingColor, LoadingType } from '@constants/loading/1.0';
import { NgClass, NgIf } from '@angular/common';
import { LoadingComponent } from '../../loading/1.0/loading.component';

@Component({
  selector: 'txp-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
  standalone: true,
  imports: [NgClass, LoadingComponent, NgIf],
})
export class ButtonComponent implements OnChanges {
  @Input() disabled: boolean;
  @Input() icon;
  @Input() loading = false;
  @Input() style: ButtonStyle;
  @Input() size: ButtonSize;
  @Input() color: LoadingColor;
  @Input() primaryColor: string; // Allow custom primary color
  // TODO: http://codelyzer.com/rules/no-output-named-after-standard-event/
  // eslint-disable-next-line @angular-eslint/no-output-native
  @Output() click = new EventEmitter<MouseEvent>();

  loadingColor = LoadingColor;
  loadingType = LoadingType;
  buttonStyle = ButtonStyle;
  buttonSize = ButtonSize;
  classes;

  ngOnChanges(changes: SimpleChanges): void {
    const cssClasses: string[] = [];
    if (this.style === ButtonStyle.PRIMARY) {
      this.color = LoadingColor.WHITE;
    }
    if (this.style === ButtonStyle.SECONDARY) {
      this.color = LoadingColor.ORANGE;
    }
    cssClasses.push(this.style);
    cssClasses.push(this.size);
    if (this.loading || this.disabled) {
      cssClasses.push('disabled');
      if (this.loading) {
        cssClasses.push('is-loading');
      }
    }

    this.classes = cssClasses.join(' ');
  }

  onClick(event: MouseEvent) {
    event.stopPropagation();
    if (!(this.disabled || this.loading)) {
      this.click.emit(event);
    }
  }
}
